import {Portal, PortalProps, registerPortalRoot} from './Portal'

export default Portal
export {registerPortalRoot}
export type {PortalProps}
